import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    pagination: {
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-end',
        padding: '20px',
    },
}));
